export default (selector, callback) => {
  const observer = new MutationObserver((mutations, mutObserver) => {
    const element = document.querySelector(selector);

    if (element) {
      mutObserver.disconnect();
      callback(element);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};
